export const DEFAULT_ANNOTATION_FEATURES = Object.freeze({
	beatAnnotation: true,
	intervalAnnotation: true,
	medianBeatFiducialPointAnnotation: true,
	jsonView: true,
	rmsView: true,
	algorithmAnalysisView: true,
	doctorNoteRequired: false,
})

export const resolveAnnotationFeatures = (annotations) => {
	const configured = annotations?.annotationFeatures || {}
	return {
		beatAnnotation: configured.beatAnnotation !== false,
		intervalAnnotation: configured.intervalAnnotation !== false,
		medianBeatFiducialPointAnnotation: configured.medianBeatFiducialPointAnnotation !== false,
		jsonView: configured.jsonView !== false,
		rmsView: configured.rmsView !== false,
		algorithmAnalysisView: configured.algorithmAnalysisView !== false,
		doctorNoteRequired: configured.doctorNoteRequired === true,
	}
}

